import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import type { TIrrigationZoneEmitter } from 'stores/fieldAssetStore/helperTypes'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export type TApplicationRate = {
  mmPerHour: number
  isDefault: boolean
}

export type TFlowRateMetadata = {
  flowRate: number | null
  flowRateIsDefault: boolean
  flowUnitPerHour: 'INCH' | 'MM'
}

export const getApplicationRateFromMetadata = (metadata?: TFlowRateMetadata): TApplicationRate | null => {
  if (!metadata || isNil(metadata.flowRate)) return null

  const mmPerHour = unitConverter
    .irrigationApplicationRate(metadata.flowRate, {
      inputUnit: metadata.flowUnitPerHour === 'INCH' ? 'in' : 'mm',
      outputUnit: 'mm',
    })
    .valueWithNoRounding()

  if (isNil(mmPerHour)) return null

  return { mmPerHour, isDefault: metadata.flowRateIsDefault }
}

export const getApplicationRateFromFlowRate = (
  flowRate?: TIrrigationZoneEmitter['flowRate'],
): TApplicationRate | null => {
  if (!flowRate || isNil(flowRate.mmPerHour)) return null

  return { mmPerHour: flowRate.mmPerHour, isDefault: flowRate.isDefault }
}

export const formatApplicationRate = (applicationRate: TApplicationRate | null): string => {
  if (!applicationRate) return ''

  const rate = unitConverter.irrigationApplicationRate(applicationRate.mmPerHour).valueWithSuffix()

  if (!applicationRate.isDefault) return rate

  return translate.phrases.templates('{{labelA}} ({{labelB}})', {
    labelA: rate,
    labelB: translate.phrases.banyanApp('Default'),
  })
}
